import {
  type AppliedRangeFilter,
  type GetSearchResultsPageByUrlQuery,
} from '@/generated/graphql-types'
import { type SearchActionsResult } from '@/hooks/srp/useSearchActions'
import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'
import { sendToLogger } from '@/utils/sendToLogger'

import { updateRangeFilter } from './updateRangeFilter'

export const selectRangeValue = async ({
  appliedFilters,
  data,
  maxValue,
  minValue,
  name,
  refetchResults,
}: {
  appliedFilters: AppliedRangeFilter[]
  data?: GetSearchResultsPageByUrlQuery['searchResultsPageByUrl']
  maxValue?: number
  minValue?: number
  name: string
  refetchResults: SearchActionsResult['refetchResults']
}) => {
  trackEvent({
    action: GA_EVENT.FilterSelectAttributeAttempt,
    label: `${name} = [${minValue}, ${maxValue}]`,
  })

  if (!data) {
    sendToLogger('"selectRangeValue" called with no data', {
      tags: { component: 'SRP Filters', fn: 'selectRangeValue' },
      fingerprint: ['selectRangeValue'],
    })
    return
  }

  const updatedRange = updateRangeFilter({
    filterName: name,
    max: maxValue,
    min: minValue,
    rangeFilters: appliedFilters,
  })

  await refetchResults(data, { newRangeFilters: updatedRange })
}
